import service from "@/store/services/locations-service";
import localStorageService from "../services/local-storage-service";

const KEY_GLOBAL_LOCATIONS = "GLOBAL_LOCATIONS";

export const state = {
  list: {},
  location: {},
  meta: {},
  globalLocations: [],
};

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, location) => {
    state.location = location;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_GLOBAL_LOCATIONS: (state, locations) => {
    state.globalLocations = locations;
  },
};

export const actions = {
  initState({ commit, dispatch, rootGetters }) {
    let locations = localStorageService.get(KEY_GLOBAL_LOCATIONS);

    if (!locations || !Array.isArray(locations)) {
      locations = [];
    }

    const me = rootGetters["profile/me"];

    if (me?.restrict_to_locations) {
      // const allowedLocationsIds =
      //   me?.allowedLocations?.map((location) => location.id) ?? [];

      locations = me?.allowedLocations;

      // if (!allowedLocationsIds.includes(location?.id)) {
      //   locations = me?.allowedLocations[0] ?? null;
      // }
    }

    if (locations) {
      dispatch("setGlobalLocations", locations);
    }
  },

  list({ commit, dispatch }, params = {}) {
    return service.list(params).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params).then((location) => {
      commit("SET_RESOURCE", location);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params).then((location) => {
      commit("SET_RESOURCE", location);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params).then((location) => {
      commit("SET_RESOURCE", location);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params);
  },

  attachUsers({ commit, dispatch }, params) {
    return service.attachUsers(params).then((location) => {
      commit("SET_RESOURCE", location);
    });
  },

  detachUsers({ commit, dispatch }, params) {
    return service.detachUsers(params).then((location) => {
      commit("SET_RESOURCE", location);
    });
  },

  setGlobalLocations({ commit, dispatch }, locations) {
    if (!locations || !Array.isArray(locations)) {
      locations = [];
    }

    const organization = (locations[0] ?? null)?.organization ?? null;

    dispatch("organizations/setGlobalOrganization", organization, {
      root: true,
    });
    commit("SET_GLOBAL_LOCATIONS", locations);
    localStorageService.save(KEY_GLOBAL_LOCATIONS, locations);
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  location: (state) => state.location,
  globalLocations: (state) => state.globalLocations,
  globalLocationsId: (state) => state.globalLocations.map((item) => item.id),
  dropdown: (state) => {
    return state.list.map((location) => ({
      id: location.id,
      name: location.name,
    }));
  },
};

const locations = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default locations;
